"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/portal_service.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalGoodsServiceGetGoodsListResponse = exports.PortalGoodsServiceGetGoodsListRequest = exports.PortalGoodsServiceGetGoodsMetadataResponse = exports.PortalGoodsServiceGetGoodsMetadataRequest = exports.PortalGoodsServiceGetGoodsResponse = exports.PortalGoodsServiceGetGoodsRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const portal_common_pb_1 = require("./portal_common_pb");
/**
 * @generated from message spwn.goods.v1.PortalGoodsServiceGetGoodsRequest
 */
class PortalGoodsServiceGetGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsServiceGetGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsServiceGetGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsServiceGetGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsServiceGetGoodsRequest, a, b);
    }
}
exports.PortalGoodsServiceGetGoodsRequest = PortalGoodsServiceGetGoodsRequest;
PortalGoodsServiceGetGoodsRequest.runtime = protobuf_1.proto3;
PortalGoodsServiceGetGoodsRequest.typeName = "spwn.goods.v1.PortalGoodsServiceGetGoodsRequest";
PortalGoodsServiceGetGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsServiceGetGoodsResponse
 */
class PortalGoodsServiceGetGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsServiceGetGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsServiceGetGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsServiceGetGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsServiceGetGoodsResponse, a, b);
    }
}
exports.PortalGoodsServiceGetGoodsResponse = PortalGoodsServiceGetGoodsResponse;
PortalGoodsServiceGetGoodsResponse.runtime = protobuf_1.proto3;
PortalGoodsServiceGetGoodsResponse.typeName = "spwn.goods.v1.PortalGoodsServiceGetGoodsResponse";
PortalGoodsServiceGetGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: portal_common_pb_1.PortalGoods },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsServiceGetGoodsMetadataRequest
 */
class PortalGoodsServiceGetGoodsMetadataRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsServiceGetGoodsMetadataRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsServiceGetGoodsMetadataRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsServiceGetGoodsMetadataRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsServiceGetGoodsMetadataRequest, a, b);
    }
}
exports.PortalGoodsServiceGetGoodsMetadataRequest = PortalGoodsServiceGetGoodsMetadataRequest;
PortalGoodsServiceGetGoodsMetadataRequest.runtime = protobuf_1.proto3;
PortalGoodsServiceGetGoodsMetadataRequest.typeName = "spwn.goods.v1.PortalGoodsServiceGetGoodsMetadataRequest";
PortalGoodsServiceGetGoodsMetadataRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsServiceGetGoodsMetadataResponse
 */
class PortalGoodsServiceGetGoodsMetadataResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsServiceGetGoodsMetadataResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsServiceGetGoodsMetadataResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsServiceGetGoodsMetadataResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsServiceGetGoodsMetadataResponse, a, b);
    }
}
exports.PortalGoodsServiceGetGoodsMetadataResponse = PortalGoodsServiceGetGoodsMetadataResponse;
PortalGoodsServiceGetGoodsMetadataResponse.runtime = protobuf_1.proto3;
PortalGoodsServiceGetGoodsMetadataResponse.typeName = "spwn.goods.v1.PortalGoodsServiceGetGoodsMetadataResponse";
PortalGoodsServiceGetGoodsMetadataResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_metadata", kind: "message", T: portal_common_pb_1.PortalGoodsMetadata },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsServiceGetGoodsListRequest
 */
class PortalGoodsServiceGetGoodsListRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: bool available_only = 2;
         */
        this.availableOnly = false;
        /**
         * @generated from field: int32 page = 3;
         */
        this.page = 0;
        /**
         * @generated from field: spwn.goods.v1.PortalGoodsType goods_type = 4;
         */
        this.goodsType = portal_common_pb_1.PortalGoodsType.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsServiceGetGoodsListRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsServiceGetGoodsListRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsServiceGetGoodsListRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsServiceGetGoodsListRequest, a, b);
    }
}
exports.PortalGoodsServiceGetGoodsListRequest = PortalGoodsServiceGetGoodsListRequest;
PortalGoodsServiceGetGoodsListRequest.runtime = protobuf_1.proto3;
PortalGoodsServiceGetGoodsListRequest.typeName = "spwn.goods.v1.PortalGoodsServiceGetGoodsListRequest";
PortalGoodsServiceGetGoodsListRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "available_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "goods_type", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.PortalGoodsType) },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsServiceGetGoodsListResponse
 */
class PortalGoodsServiceGetGoodsListResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.goods.v1.PortalGoods goods_list = 1;
         */
        this.goodsList = [];
        /**
         * @generated from field: int32 total_pages = 2;
         */
        this.totalPages = 0;
        /**
         * @generated from field: int32 current_page = 3;
         */
        this.currentPage = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsServiceGetGoodsListResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsServiceGetGoodsListResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsServiceGetGoodsListResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsServiceGetGoodsListResponse, a, b);
    }
}
exports.PortalGoodsServiceGetGoodsListResponse = PortalGoodsServiceGetGoodsListResponse;
PortalGoodsServiceGetGoodsListResponse.runtime = protobuf_1.proto3;
PortalGoodsServiceGetGoodsListResponse.typeName = "spwn.goods.v1.PortalGoodsServiceGetGoodsListResponse";
PortalGoodsServiceGetGoodsListResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_list", kind: "message", T: portal_common_pb_1.PortalGoods, repeated: true },
    { no: 2, name: "total_pages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "current_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
//# sourceMappingURL=portal_service_pb.js.map